import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar } from './Sidebar';

export function UserSidebar({ user, onLogout, onCollapseChange }) {
  const getPortalLabel = (role) => {
    switch (role) {
      case 'farmer': return 'Farmer Portal';
      case 'processor': return 'Processor Portal';
      case 'admin': return 'Admin Portal';
      default: return 'User Portal';
    }
  };

  const getBadgeBg = (role) => {
    switch (role) {
      case 'farmer': return 'bg-green-600';
      case 'processor': return 'bg-amber-600';
      case 'admin': return 'bg-emerald-600';
      default: return 'bg-blue-500';
    }
  };

  return (
    <Sidebar
      user={user}
      onLogout={onLogout}
      portalLabel={getPortalLabel(user?.role)}
      badgeBg={getBadgeBg(user?.role)}
      onCollapseChange={onCollapseChange}
    />
  );
}

UserSidebar.propTypes = {
  user: PropTypes.object.isRequired,
  onLogout: PropTypes.func.isRequired,
  onCollapseChange: PropTypes.func,
};
